import useUIState from 'src/state/ui/persistUiState';
import { DocsActionBarUIState } from 'src/state/ui/types';

export const useDocsActionBarUIState = (): DocsActionBarUIState =>
  useUIState((state) => ({
    docsIDList: state.docsIDList,
    addDocToList: (docId: string) => state.addDocToList(docId),
    deleteDocFromList: (docId: string) => state.deleteDocFromList(docId),
  }));
